import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import { Auth } from '../../StateManagment/Auth';
import { useContext } from "react";
import { useHistory } from 'react-router-dom';
import { client } from "../../hooks/Client"
import { ActiveMenu } from "../../StateManagment/ActiveMenuItem";

const Portfolio = () => {
  // Context
  const [auth] = useContext(Auth)
  const { active, setActive, activeSubItem, setActiveSubItem } = useContext(ActiveMenu);

  // Hooks
  const history = useHistory()

 const segmentSteps = [
  {
    name: 'Projecten',
    url: 'projects'
  },
  {
    name: 'Overzicht',
    url: 'projectsOverview'
  }
]

  return (
    <div className="main">
      <div className="main-container">
          <div className="page-header">
              <BusinessOutlinedIcon/>
              <h1>Portfolio</h1>
          </div>
        <div className='section-explainer-text-container'>
          <div>
            <p>Welkom bij portfolio omgeving, {auth?.ForName}. Hier kun je aan de slag met je portfolio-projecten.</p>
          </div>
          <div id='segment-overview-steps-container'>
            {segmentSteps.map((step, index) => (
              <div 
              key={index} 
              className="segment-overview-step-container"
              onClick={() => {
                history.push(`/${client}/${step.url}`);
                setActive('portfolio');
                setActiveSubItem(step.url)
              }}
              >
                <div className="segment-overview-step-inner-container">
                  <div className="segment-overview-checked-name-container">
                    <div>
                      <p><b>{step.name}</b></p>
                    </div>
                  </div>
                  <p id='segment-overview-step-button'>Bekijk/aanpassen</p>
                </div>
                
              </div>
            ))}
          </div>
        </div>
      </div>
  </div>
  )
}

export default Portfolio